export type ConfigurationStatus = 'drafting' | 'pending_review' | 'live' | 'offboarded';

/**
 * Single source of truth for "is this configuration publicly visible on the customer site."
 *
 * Prefers the `status` enum (`status === 'live'`), falling back to the legacy `isActive`
 * boolean only when a document predates the `status` backfill. Once `isActive`/`sierraActive`
 * are fully retired, the fallback can be removed and this becomes `config.status === 'live'`.
 */
export function isConfigurationLive(config?: { status?: ConfigurationStatus; isActive?: boolean } | null): boolean {
    if (!config) return false;
    return config.status ? config.status === 'live' : !!config.isActive;
}
